export default __webpack_public_path__ + "static/media/txt.a281c866.svg";